import React, { useMemo } from 'react';
import * as mobxReact from 'mobx-react';
import classnames from 'classnames';
import { GroupCollapseIcon } from '../../../../global/group-collapse-icon/group-collapse-icon';
import { IAssetsOrganizationListItemDTO, IAssetsSpeakersDetailsDTO } from '../../../../../api/assets.dao';
import { AssetBiographyItem } from './assets-biography-item';
import { AssetSpeakerItem } from './assets-speaker-item';

import '../assets.scss';

interface IProps {
    onExpandGroup: (group: string) => void;
    onCollapseGroup: (group: string) => void;
    collapsedGroups: string[];
    categoryGroup: { type: string; label: string };
    assetsSpeakersGroupedList: IAssetsSpeakersDetailsDTO[];
    accountId: number;
    eventId: number;
    organization: IAssetsOrganizationListItemDTO;
    uploadProfileImage: (file: File, organizationId: number, attendeeId: number) => Promise<void>;
    onDeleteAsset: (organizationId: number, attendeeId: number) => void;
    currentDroppableElementId: number;
    updateAttendeePermission: boolean;
    setSpeakerBiography: (biography: string, organizationId: number, attendeeId: number) => void;
}

const AssetsListOrganizationItem = mobxReact.observer((props: IProps) => {
    const {
        collapsedGroups,
        onExpandGroup,
        onCollapseGroup,
        categoryGroup,
        assetsSpeakersGroupedList,
        accountId,
        eventId,
        organization,
        uploadProfileImage,
        onDeleteAsset,
        currentDroppableElementId,
        updateAttendeePermission,
        setSpeakerBiography
    } = props;

    const isGroupCollapsed = useMemo(() => collapsedGroups.some(el =>
        el === categoryGroup.type
    ), [collapsedGroups, categoryGroup.type]);

    const handleCollapseGroupToggle = () => {
        if (isGroupCollapsed) {
            onExpandGroup(categoryGroup.type);
        } else {
            onCollapseGroup(categoryGroup.type);
        }
    };

    return (
        <table className='table-list-layout w-100' cellPadding={0} cellSpacing={0}>
            <thead>
                <tr className='assets-list-group-header'>
                    <th className={classnames('assets-speakers-table__header', { 'assets-list-group-header__collapsed': isGroupCollapsed })} colSpan={3}>
                        <div className='assets-list-group-header__title-block' onClick={handleCollapseGroupToggle}>
                            <GroupCollapseIcon isCollapsed={isGroupCollapsed} isAllItemsCollapsed={false} />
                            <div className='assets-list-group-header__organization-title'>
                                {categoryGroup.label}
                            </div>
                        </div>
                    </th>
                    <th className={classnames({ 'assets-list-group-header__collapsed': isGroupCollapsed })} />
                    <th className={classnames({ 'assets-list-group-header__collapsed': isGroupCollapsed })} />
                </tr>
            </thead>
            <tbody className='table-list-layout__tbody'>
                {!isGroupCollapsed
                    && assetsSpeakersGroupedList.map((attendee, index) => {
                        return (
                            <React.Fragment key={index}>
                                <AssetSpeakerItem
                                    accountId={accountId}
                                    eventId={eventId}
                                    organizationId={organization.organizationId}
                                    attendee={attendee}
                                    updateAttendeePermission={updateAttendeePermission}
                                    currentDroppableElementId={currentDroppableElementId}
                                    uploadProfileImage={uploadProfileImage}
                                    onDeleteAsset={onDeleteAsset}
                                />
                                <AssetBiographyItem
                                    accountId={accountId}
                                    eventId={eventId}
                                    organizationId={organization.organizationId}
                                    attendee={attendee}
                                    updateAttendeePermission={updateAttendeePermission}
                                    setSpeakerBiography={setSpeakerBiography}
                                />
                            </React.Fragment>
                        );
                    }
                    )}
            </tbody>
        </table>
    );
});

export { AssetsListOrganizationItem };